import { useTranslation } from 'react-i18next';

import { Invoice } from 'lane-shared/domains/billingPayments/types';
import { useSrInvoiceBilledStatusEnabled } from 'react-hooks';
import { MARK_AS_BILLED_ACTION_ID } from 'domains/billingAndPayments/invoiceBilling/invoiceRowActionAvailability';

import { confirmAndMarkAsBilled } from './confirmAndMarkAsBilled';
import { useMarkInvoiceAsBilled } from './useMarkInvoiceAsBilled';

export function useMarkAsBilledRowAction() {
  const { t } = useTranslation();
  const isBilledStatusEnabled = useSrInvoiceBilledStatusEnabled();
  const { markAsBilled } = useMarkInvoiceAsBilled();

  if (!isBilledStatusEnabled) return [];

  return [
    {
      label: t('abp.actions.markAsBilled'),
      testId: MARK_AS_BILLED_ACTION_ID,
      onSelect: (_: unknown, invoice: Invoice) =>
        confirmAndMarkAsBilled({ invoice, markAsBilled, t }),
    },
  ];
}
